export default __webpack_public_path__ + "static/media/market.4168f9b2.mp4";